import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import logo from "../../assets/images/logo.png";
import { AnimatePresence, motion } from "framer-motion";
import ImageDropzone from "./ImageDropzone";
import ImageDropzone1 from "./ImageDropzone1";
import VerifyOTP from "./VerifyOTP";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AuthGuard from "../../components/AuthGuard";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

const CompanyForm = () => {
  const [view, setView] = useState("main");

  const [tradeLicenseFile, setTradeLicenseFile] = useState(null);
  const [vatCertificateFile, setVatCertificateFile] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [formData, setFormData] = useState({
    trade_license_no: "",
    reg_date: null,
    trn: ""
  });
  const [errors, setErrors] = useState({
    reg_date: null
  });
  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
    const { t, i18n } = useTranslation();
          const isRTL = i18n.language === 'ar';
  const handleRegYearChange = (date) => {
    const currentDate = new Date();
    let errorMessage = null;
  
    if (date) {
      if (date < currentDate.setHours(0, 0, 0, 0)) {
        errorMessage = "Expiry date must be in the future.";
      }
    }
  
    setFormData((prev) => ({
      ...prev,
      reg_date: date,
    }));
  
    setErrors((prev) => ({
      ...prev,
      reg_date: errorMessage,
    }));
  };
  
  const saved = JSON.parse(localStorage.getItem("companyInfo") || "{}");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleUploadDocuments = async () => {
    if (!tradeLicenseFile) {
      toast.error("Please attach your Trade Licence.");
      return;
    }
    if (!vatCertificateFile) {
      toast.error("Please attach your VAT Certificate.");
      return;
    }

    const uploadData = new FormData();
    uploadData.append("trade_license", tradeLicenseFile);
    uploadData.append("vat_certificate", vatCertificateFile);
    
    uploadData.append("trade_license_no", formData.trade_license_no || "");
    uploadData.append("reg_date", formData.reg_date ? formData.reg_date.toISOString() : "");
    uploadData.append("trn", formData.trn || "");
    uploadData.append("check_validation", false);
    
    Object.entries(saved).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        uploadData.append(key, value);
      }
    });
    
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "POST",
        url: "/company/register",
        data: uploadData,
        headers: { "Content-Type": "multipart/form-data" },
      });
    

      const { status, message, data } = response.data;
      if (status) {
        const company_id = data?._id;
        // console.log(data);
        localStorage.setItem("company_id", company_id);
    // const company = { ...data.company, auth_token: data.auth_token };
    //     localStorage.setItem("company", JSON.stringify(company));
    //     let user = data.data.company;
    //     user.auth_token = data.data.auth_token;
    //     localStorage.setItem("company", JSON.stringify(data.data.company));
        toast.success(message || "Documents uploaded successfully.");
        setView("otp");
      } else {
        toast.error(message || "Upload failed. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong while uploading. Please try again.");
    } finally {
      setIsLoader(false);
    }
  };
  const handleSkip = async() => {
    const formData = new FormData();
    formData.append("check_validation", false);

      Object.entries(saved).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      });
  
      try {
        const response = await ApiService.request({
          method: "POST",
          url: "/company/register",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });
  
        const { status, message, data } = response.data;
        if (status) {
          const company_id = data?._id;
    // const company = { ...data.company, auth_token: data.auth_token };
        // localStorage.setItem("company", JSON.stringify(company));
        // localStorage.setItem("company", JSON.stringify(data.data.company));
                   localStorage.setItem("company_id", company_id);
            setView("otp");
        } 
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong while uploading. Please try again.");
      } 

  };

  return (
    <AuthGuard>
    <AnimatePresence mode="wait">
      {view === "main" && (
        <motion.div
          key="main"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.5 }}
          className="inter-font main-bg min-vh-100 d-flex flex-column md:mt-5 justify-content-center align-items-center position-relative px-3"
        >
          {/* Header with logo and stepper */}
          <Container fluid className="inter-font position-absolute top-0 mt-3">
            <Row className="inter-font align-items-center">
              <Link
              to={"/"}
                xs={12}
                md={1}
                className="col inter-font text-center text-md-start mb-3 mb-md-0 cursor-pointer"
              >
                <img src={logo} alt="Logo" style={{ height: "50px" }} />
              </Link>
         <Col xs={12} md={11} className="inter-font text-center">
  <div className="inter-font d-flex flex-md-row align-items-center justify-content-center gap-2">
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step>1</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("select_company")}
      </span>
    </div>
    <Arrow />
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step>2</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("add_information")}
      </span>
    </div>
    <Arrow />
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step active>3</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("upload_documents")}
      </span>
    </div>
  </div>
</Col>
            </Row>
          </Container>

         <div
  className="inter-font container upload-doc-coontainer bg-white p-4 d-flex flex-column justify-content-center align-items-center rounded-4"
  style={{ width: "100%", maxWidth: "700px", marginTop: "300px", direction: isRTL ? "rtl" : "ltr" }}
>
  <h2 className="inter-font fw-bold text-center" style={{ textAlign: isRTL ? "right" : "left" }}>
    {t("c_reg_s3_title")}
  </h2>
  <p
    className="inter-font text-center"
    style={{ color: "rgba(0, 0, 0, 0.3)", textAlign: isRTL ? "right" : "left" }}
  >
    {t("c_reg_s3_dec")}
  </p>
  <Row className="mt-4 w-100">
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
          {t("c_ff_text47")}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={t("c_ff_text48")}
          name="trade_license_no"
          value={formData.trade_license_no}
          onChange={(e) => {
            if (/^[a-zA-Z0-9]*$/.test(e.target.value)) {
              handleTextChange(e);
            }
          }}
          className="inter-font inp-bg sofia-font inp-login"
          style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
        />
      </Form.Group>
    </Col>
    <Col md={6} className="inter-font">
      <Form.Group className="mb-3">
        <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
          {t("c_ff_text57")}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={t("c_ff_text58")}
          name="trn"
          value={formData.trn}
          onChange={handleTextChange}
          className="inter-font inp-bg sofia-font inp-login"
          style={{ textAlign: isRTL ? "right" : "left", direction: "ltr" }}
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group className="inter-font mb-3">
        <Form.Label style={{ textAlign: isRTL ? "right" : "left" }}>
          {t("c_ff_text49")}
        </Form.Label>
        <DatePicker
          selected={formData.reg_date ? new Date(formData.reg_date) : null}
          onChange={handleRegYearChange}
          dateFormat="dd/MM/yyyy"
          placeholderText={t("c_ff_text50")}
          className={`form-control w-100 inter-font inp-bg sofia-font inp-login ${
            errors.reg_date ? "is-invalid" : ""
          }`}
          minDate={new Date()}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          wrapperClassName="w-100"
        />
        {errors.reg_date && (
          <div className="invalid-feedback d-block" style={{ textAlign: isRTL ? "right" : "left" }}>{errors.reg_date}</div>
        )}
      </Form.Group>
    </Col>
  </Row>

  <div className="inter-font d-flex flex-column flex-md-row justify-content-center align-items-center mt-3 gap-3 w-100">
    {/* Trade Licence */}
    <div className="inter-font attachImg d-flex flex-column justify-content-center align-items-center w-100">
      <ImageDropzone
        title={t("c_ff_text63")}
        setFiles={(files) => setTradeLicenseFile(files?.[0] || null)}
      />
    </div>

    {/* VAT Certificate */}
    <div className="inter-font attachImg d-flex flex-column justify-content-center align-items-center w-100">
      <ImageDropzone1
        title={t("c_ff_text60")}
        setFiles={(files) => setVatCertificateFile(files?.[0] || null)}
      />
    </div>
  </div>

  <button
    className="inter-font btn btn-base mt-4"
    onClick={handleUploadDocuments}
    disabled={isLoader}
    style={{
      backgroundColor: "#E26A52",
      color: "#fff",
      border: "none"
    }}
  >
    {isLoader ? t("uploading") : t("c_ff_text62")}
  </button>
  <div className="mt-3">
    <div 
      style={{
        color: "#E46A56",
        background: "none",
        fontSize: "18px",
        cursor: "pointer"
      }} 
      onClick={handleSkip}
      className="text-decoration-underline"
    >
      {t("skip")}
    </div>
  </div>
</div>        </motion.div>
      )}

      {view === "otp" && (
        <motion.div
          key="otp"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.5 }}
        >
          <VerifyOTP />
        </motion.div>
      )}
    </AnimatePresence>
    </AuthGuard>
  );
};

const Step = ({ children, active }) => (
  <div
    className={ `inter-font rounded-circle d-flex num-circle align-items-center justify-content-center fw-bold ${
      active ? "bg-dark text-white" : "bg-light text-muted"
    }`}
    style={{ width: "30px", height: "30px", fontSize: "14px" }}
  >
    {children}
  </div>
);

const Arrow = () => <span className="inter-font text-muted">→</span>;

export default CompanyForm;
